// extracted by mini-css-extract-plugin
export default {"wrapper":"TextCheckbox_wrapper__xq3GX"};